import { useRef } from "react";
import Welcome from "./Welcome";
import Cds from "./Cds";
import Conductor from "./Conductor";
import UpcomingEvents from "./UpcomingEvents";
import Who from "./Who";
import SupportAndNews from "./SupportAndNews";
import Carousel from "./Carousel";
import SEO from "../common/SEO";

const Home = ({ concerts, news, cds, testimonials, formatDate }) => {
  const sectionRef = useRef(null);

  return (
    <>
      <SEO
        title="Nuova Orchestra da Camera Ferruccio Busoni"
        description="Sito ufficiale della Nuova Orchestra da Camera Ferruccio Busoni di Trieste. Complesso storico fondato nel 1965 da Aldo Belli e diretto da Massimo Belli. Scopri concerti, discografia e Mattinate Musicali Internazionali."
        image="/img/homeBkg.jpg"
      />

      <Welcome sectionRef={sectionRef} />
      <Cds cds={cds} />
      <Conductor />
      <UpcomingEvents concerts={concerts} sectionRef={sectionRef} />
      <Who />
      <SupportAndNews news={news} formatDate={formatDate} />
      <Carousel testimonials={testimonials} />
    </>
  );
};

export default Home;
